<template>
    <div class="preview">
        <img src="@/assets/FrontPage/LogoAndCover/MobilePreview.svg" alt="">
        <div class="mobile-screen">
            <div class="cover" v-if="!isCoverSelected"></div>

            <div class="uploaded-cover" v-if="isCoverSelected">
                <img :src="coverPreview" alt="">
            </div>

            <div class="logo flex --font" v-if="!isLogoSelected">
                Logo
            </div>

            <div class="logo flex --font" v-if="isLogoSelected">
                <img class="" :src="logoPreview" alt="">
            </div>

            <div class="bottom-section flex">
              
                <div class="content-section">
                    <h3 class="--font"> {{ brandDetails.name }} </h3>
                    <small class="secondary-font"> {{ brandDetails.description }} </small>
                </div>  
                <div class="external-links flex">
                    <img v-if="brandDetails.shareSource === 'youtube'" :src="YouTube" alt="">
                    <img v-else-if="brandDetails.shareSource === 'app_link'" :src="PlayStore" alt="">
                    <img v-else :src="website" alt="">
                    <v-icon color="#419045" class="ml-3">mdi-share-variant-outline</v-icon>
                </div>
            </div>

            <div class="buttons flex">
                <div>
                    <button class="--weight follow"> + Follow </button>
                </div>
                <div>
                    <button class="--blue --weight message"> Send Message </button>
                </div>
                <div style="width : 10%" v-if="brandDetails.contactSource">
                    <button class="call__whatsapp flex"> 
                        <img :src="brandDetails.contactSource === 'call' ? callLogo : whatsAppLogo" alt="">     
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'mobilePreview',

    data() {
        return {
            companyDetails : {
                heading : '',
                description : ''
            },
            logoPreview : null,
            coverPreview : null,
            isLogoSelected : false,
            isCoverSelected : false,
            callLogo : require("../../../assets/FrontPage/call.svg"),
            whatsAppLogo : require("../../../assets/FrontPage/WhatsApp.svg"),
            website : require("../../../assets/FrontPage/Website.svg"),
            YouTube : require("../../../assets/FrontPage/YouTube.svg"),
            PlayStore : require("../../../assets/FrontPage/PlayStore.svg"),
        }
    },

    props : {
        brandDetails : {
            type : Object
        }
    },

    mounted() {
        setTimeout(() => {
            console.log(this.brandDetails);
        }, 1000);
    },

    watch : {
        logoPreview : function(value) {
            if(value)
                this.isLogoSelected = true;
            else
                this.isLogoSelected = false;
        },

        coverPreview : function(value) {
            if(value)
                this.isCoverSelected = true;
            else
                this.isCoverSelected = false;
        },
    },

    methods : {
        getLogoPreview(URL) {
            console.log("I am fired");
            this.isLogoSelected = true;
            this.logoPreview = URL;
        },

        getCoverPreview(URL) {
            this.isCoverSelected = true;
            this.coverPreview = URL;
        }
    },
}
</script>

<style lang="scss" scoped>

.set-up-page {
    height: 100vh;
}

.preview {
    width: 100%;
    margin-right: 80px;
    position: relative;
    border-radius: 30px;
}

.preview img {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mobile-screen {
    width: 91%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    position: absolute;
    top: 0;
    border-radius: 30px;
    padding-top: 10px;
}

.cover {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    height: 180px;
    width: 100%;
    background-color: #dfdfdf;

    img {
        width: 100%;
        height: 100%;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
    }
}

.uploaded-cover {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    height: 180px;
    width: 100%;
    position: relative;
    z-index: 0;
}

.logo {
    width: 100px;
    height: 100px;
    background-color: #c4c4c4;
    border-radius: 50%;
    transform: translate(10px, -50px);

    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
}

.bottom-section {
    padding: 0 15px;
    align-items: flex-start;
    justify-content: space-between;
    transform: translateY(-30px);
    box-sizing: border-box;
   
    white-space: pre-line;
   
}
.content-section{
    width: 250px;
    height: 110px;
    overflow-wrap: break-word;
    

}
.secondry-font{
    height: 10px;
     box-sizing: border-box;
}


.bottom-section img {
    width: 25px;
    height: 25px;
}

.buttons div{
    width: 42%;
    height: 50px;
}

.buttons {
    width: 95%;
    margin: auto;
    justify-content: space-between;
    padding-right: 9px;
}

.buttons img {
    width: 20px;
}

.buttons button{
    width: 100%;
    border-radius: 3px;
    padding: 10px 5px;
}

.upload-section {
    width: 30%;
}

.follow {
    background: #419045;
    box-shadow: 1px 3px 3px rgba(46, 73, 50, 0.25);
    color: white;
}

.message, .call__whatsapp {
    background-color: #E8EEF2;
}
</style>